module.exports = __webpack_public_path__ + "img/slider-image-12.66087eaa.jpg";